import type { Invoice } from "@/graphql/codegen/graphql"
import {
  isApproveSyncFailed,
  isApproveSyncInProgress,
  isResubmissionReversalInProgress,
} from "@/screens/Accounting/subfeatures/Invoices/utils/invoiceAs400Sync"

// Per parent AK-5096 AC and epic AK-5066 rule "the last person to enter or edit an invoice cannot
// approve". Returns false when the active user is the invoice's creator OR the last editor —
// hiding the Approve action on the Review modal. Defense-in-depth only: BE also enforces
// `SelfApprovalForbidden` on the `statusChange` mutation.
export const canApproveInvoice = (invoice: Invoice, currentUserId: string | undefined | null): boolean => {
  if (!currentUserId) return false
  if (invoice.createdBy && invoice.createdBy === currentUserId) return false
  // AK-5232 AC3: the approver selects Approve again to retry. The first approval already recorded the approver as
  // the last editor, so a retry cannot be blocked by that rule.
  if (isApproveSyncFailed(invoice)) return true
  if (invoice.updatedBy && invoice.updatedBy === currentUserId) return false
  return true
}

// AK-5232 AC2, AK-5649 AC4: Review and Approve wait while the approval voucher, or the reversal of a resubmitted
// invoice, is still syncing with AS400.
export const isReviewBlockedBySync = (invoice: Invoice): boolean =>
  isApproveSyncInProgress(invoice) || isResubmissionReversalInProgress(invoice)
